const PSEvents = require('PSEvents');
const PSState = require('PSState');

cc.Class({
    extends: cc.Component,

    onLoad () {
        PSEvents.subscribe(PSEvents.START_REPLAY,this.onStartReplay.bind(this), this);
        PSEvents.subscribe(PSEvents.STOP_REPLAY,this.onStopReplay.bind(this), this);
    },

    onDestroy() {
        PSEvents.removeAllListenerByTarget(this);
    },

    onStartReplay(data) {
        PSState.set( { wagers: data.wagers });
    },

    onStopReplay() {
        PSState.set( { wagers: null });
    }
});
